import type { FC, ReactNode } from "react";
import { useState } from "react";
import type { AppLocale } from "@akina/infra";
import { Popover } from "../../atoms";
import { Calendar } from "./Calendar";

export type DatePickerProps = {
  trigger: ReactNode;
  date?: Date;
  onChange?: (date: Date) => void;
  locale?: AppLocale;
  searchPlaceholder?: string;
}

export const DatePicker: FC<DatePickerProps> = ({ trigger, date, onChange, locale, searchPlaceholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover open={isOpen} onOpenChange={setIsOpen} trigger={trigger}>
      <Calendar
        setIsOpen={setIsOpen}
        date={date}
        onChange={onChange}
        locale={locale}
        searchPlaceholder={searchPlaceholder}
      />
    </Popover>
  );
};
